import React from "react";

interface ToggleButtonProps {
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
  size?: "sm" | "md" | "lg";
  required?: boolean;
}

export function ToggleButton({
  label,
  checked,
  onChange,
  disabled = false,
  className = "",
  labelClassName = "",
  size = "md",
  required = false,
}: ToggleButtonProps) {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  // 크기별 스타일
  const sizeStyles = {
    sm: {
      container: "w-8 h-5",
      circle: "w-4 h-4",
      translate: checked ? "translate-x-3" : "translate-x-0.5",
    },
    md: {
      container: "w-10 h-6",
      circle: "w-5 h-5",
      translate: checked ? "translate-x-4" : "translate-x-0.5",
    },
    lg: {
      container: "w-12 h-7",
      circle: "w-6 h-6",
      translate: checked ? "translate-x-5" : "translate-x-0.5",
    },
  };

  const currentSize = sizeStyles[size];

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {label && (
        <label
          className={`text-sm font-medium text-gray-700 cursor-pointer select-none ${
            disabled ? "opacity-50" : ""
          } ${labelClassName}`}
          onClick={handleToggle}
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={handleToggle}
        className={`
          relative inline-flex items-center rounded-full transition-colors duration-200 ease-in-out
          ${currentSize.container}
          ${checked ? "bg-[#83C41C]" : "bg-[#E9E9EA]"}
          ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
        `}
      >
        <span className="sr-only">{label || "Toggle"}</span>
        <span
          className={`
            ${currentSize.circle}
            inline-block rounded-full bg-white shadow transform transition-transform duration-200 ease-in-out
            ${currentSize.translate}
            ${disabled ? "" : "hover:shadow-md"}
          `}
        />
      </button>
    </div>
  );
}

export default ToggleButton;
